import styled, { css } from 'styled-components';
import DoubleArrowBlackSrc from 'assets/images/double-arrow-right-black.svg';

import { common } from 'themes/default';

import { ConfirmButton, LinkButton } from 'components/ui/Button';

export const StyledConfirmButton = styled(ConfirmButton)``;

export const StyledLinkButton = styled(LinkButton)``;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const StyledSubmitButton = styled(ConfirmButton)``;

export const StyledLabel = styled.label`
  position: absolute;
  top: -22px;
`;

export const StyledFormLabel = styled.label``;

export const StyledHeaderLabel = styled.label`
  cursor: pointer;
`;

export const FieldError = styled.div`
  color: red;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ActionHeader = styled.div`
  border-radius: 12px;
  background-color: ${(p) => (p.isComplete ? common.notifications.success.backgroundColour : common.notifications.error.backgroundColour)};
  color: ${(p) => (p.isComplete ? common.notifications.success.fontColour : common.notifications.error.fontColour)};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const ActionContent = styled.div`
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 -2px 4px rgba(255, 255, 255, 0.1);
  display: none;
  flex-direction: column;
  font-weight: bold;
  height: auto;
  padding: 0 10px 0 10px;
  overflow: hidden;

  ${(props) =>
    props.isExpanded &&
    css`
      display: flex;
      overflow: scroll;
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;

export const ToggleWrapper = styled.div`
  width: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 0;
`;

export const Toggle = styled.img`
  width: 12px;
  height: 12px;
  transition: all 0.1s ease-in-out;

  ${(props) =>
    props.isExpanded &&
    css`
      transform: rotate(90deg);
    `}
`;

Toggle.defaultProps = {
  src: DoubleArrowBlackSrc
};
